<template>
  <div class="editDict">
    <Modal
      title="编辑字典"
      v-model="modalView"
      @on-visible-change="changeVisible"
      :mask-closable="false"
      width="860"
      class="editDict-modal"
    >
      <Form
        ref="formEdit"
        :rules="ruleCustoms"
        :model="formEdit"
        :label-width="80"
      >
        <FormItem prop="itemName" label="类型名称">
          <Input
            v-filter-space
            v-model="formEdit.itemName"
            placeholder="请输入类型名称"
          >
          </Input>
        </FormItem>
        <FormItem prop="type" label="类型编码">
          <Input disabled v-model="formEdit.type" placeholder="请输入类型编码">
          </Input>
        </FormItem>
        <FormItem
          v-if="formEdit.type == 'SERVICE_NUM'"
          prop="defaultNum"
          label="默认数量"
        >
          <Input
            v-filter-space
            v-model="formEdit.defaultNum"
            placeholder="请输入默认数量"
          >
          </Input>
        </FormItem>
        <FormItem label="包含子项" style="margin-bottom: 0">
          <div class="flexfs flexwarp">
            <Tag
              size="medium"
              closable
              color="primary"
              type="dot"
              v-for="(item, index) in children"
              :key="index"
              :name="item.subName"
              @on-close="delTag(index, item)"
              @click.native="clickTag(item, index)"
              class="mr-16 mb-16"
              >{{ item.subName }} ({{ item.subValue }})</Tag
            >
          </div>
        </FormItem>
        <Row :gutter="16" type="flex" justify="start" class="ml-80">
          <Col span="10">
            <FormItem prop="subName" :label-width="80">
              <Input v-model.trim="formEdit.subName" placeholder="子项名称">
              </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem class="message-nowrap" prop="subValue" :label-width="0">
              <Input
                class="mr-16"
                v-model.trim="formEdit.subValue"
                placeholder="子项编码"
              ></Input>
            </FormItem>
          </Col>
          <Col span="5">
            <FormItem :label-width="0">
              <Button
                v-if="idx == undefined"
                class="mr-40"
                type="primary"
                :disabled="!formEdit.subName || !formEdit.subValue"
                @click="addItem()"
                >添加子项</Button
              >
              <Button
                v-else
                :disabled="!formEdit.subName || !formEdit.subValue"
                class="mr-40"
                type="warning"
                @click="editItem()"
                >更新子项</Button
              >
            </FormItem>
          </Col>
        </Row>
        <FormItem label="备注" prop="description">
          <Input
            v-model="formEdit.description"
            v-textarea-filter-space
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10 }"
            placeholder="请输入备注"
          >
          </Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button class="btn104" shape="circle" @click="cancle">取消</Button>
        <Button
          class="btn104"
          type="primary"
          :loading="loading"
          shape="circle"
          @click="confirm"
          >保存</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { putItem, verifyDelete } from "@/api/system";
export default {
  name: "",
  components: {},
  props: {
    form: Object,
    dialog: Boolean,
  },
  data() {
    return {
      loading: false,
      modalView: false,
      formEdit: {
        subName: "",
        subValue: "",
      },
      ruleCustoms: {
        itemName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入类型名称",
          },
          {
            pattern: /^[\u4e00-\u9fa50-9a-zA-Z]{1,10}$/,
            trigger: "blur",
            message: "请输入10位以内的汉字、字母、数字",
          },
        ],
        type: [
          {
            required: true,
            trigger: "blur",
            validate: _FORM.word_num_check,
            min_len: 1,
            max_len: 30,
            label: "类型编码",
          },
        ],
        subName: [
          {
            trigger: "blur",
            max: 10,
            min: 0,
            message: "子项名称控制在10字以内",
          },
        ],
        subValue: [
          {
            trigger: "blur",
            pattern: /^[A-Z_0-9]*$/,
            message: "子项编码只允许输入大写字母、数字、下划线",
          },
        ],
        defaultNum: [
          {
            required: true,
            trigger: "blur",
            message: "请输入默认数量",
          },
          {
            trigger: "blur",
            validator(rule, value, callback) {
              let reg = /^[0-9]{1,}$/;
              if (reg.test(value)) {
                if (value >= 0 && value <= 99999) {
                  callback();
                } else {
                  callback(new Error(`默认数量在0-99999之间`));
                }
              } else {
                callback(new Error(`请输入正整数`));
              }
            },
          },
        ],
        description: [
          {
            trigger: "blur",
            message: "请输入备注",
          },
          {
            trigger: "blur",
            max: 30,
            min: 0,
            message: "长度为0-30",
          },
        ],
      },
      idx: undefined,
      childrenItem: {
        itemName: "",
        itemValue: "",
      },
      children: [],
      copyList: [],
    };
  },
  watch: {
    formEdit: {
      handler(nval, oval) {
        if (nval.subName == "" && nval.subValue == "") {
          this.idx = undefined;
        }
      },
      deep: true,
    },
  },
  created() {
    this.modalView = true;
    this.valueCopy();
  },
  methods: {
    addItem() {
      // 服务评价不能超过16个
      if (this.formEdit.type == "SERVICE_TAG" && this.children.length == 16) {
        this.$Message.warning("标签数量最大为16个");
        return;
      }
      // 配额不能超过10个
      if (this.formEdit.type == "SERVICE_NUM" && this.children.length == 10) {
        this.$Message.warning("标签数量最大为10个");
        return;
      }
      let t1 = this.children.find((x) => x.itemValue == this.formEdit.subValue);
      let t2 = this.children.find((x) => x.itemName == this.formEdit.subName);
      if (t1 || t2) {
        this.$Message.error("请勿重复添加字典值");
        return;
      }
      let name = false,
        value = false;
      this.$refs.formEdit.validateField("subName", (valid) => {
        name = valid ? false : true;
      });
      this.$refs.formEdit.validateField("subValue", (valid) => {
        value = valid ? false : true;
      });
      if (name == false || !value) {
        return;
      }
      //校验子项
      let data = {
        subName: this.formEdit.subName,
        subValue: this.formEdit.subValue,
        itemName: this.formEdit.subName,
        itemValue: this.formEdit.subValue,
        parentId: this.formEdit.id,
      };
      this.children.push(data);
      // this.$set(this.formEdit,"subName","");
      // this.$set(this.formEdit,"subValue","");
      this.formEdit.subName = "";
      this.formEdit.subValue = "";
      console.log(this.formEdit, "add--");
    },
    editItem() {
      let flag = this.isRepeat();
      if (flag) {
        return;
      }
      let name = false,
        value = false;
      this.$refs.formEdit.validateField("subName", (valid) => {
        name = valid ? false : true;
      });
      this.$refs.formEdit.validateField("subValue", (valid) => {
        value = valid ? false : true;
      });
      if (name == false || !value) {
        return;
      }
      this.children[this.idx].itemName = this.formEdit.subName;
      this.children[this.idx].itemValue = this.formEdit.subValue;
      this.children[this.idx].subName = this.formEdit.subName;
      this.children[this.idx].subValue = this.formEdit.subValue;
      this.idx = undefined;
      this.$set(this.formEdit, "subName", "");
      this.$set(this.formEdit, "subValue", "");
      console.log(this.formEdit, "edit--");
      // this.formEdit.subName = "";
      // this.formEdit.subValue = "";
    },
    isRepeat() {
      let t1 = this.children.find((x) => x.itemValue == this.formEdit.subValue);
      let t2 = this.children.find((x) => x.itemName == this.formEdit.subName);
      //点击后没有修改
      //当前值和字典编码是否相等
      let t1Value = this.children[this.idx].itemValue == this.formEdit.subValue;
      //当前值和字典名称是都相等
      let t2Name = this.children[this.idx].itemName == this.formEdit.subName;
      if (t1 && !t2) {
        if (t1Value == false) {
          this.$Message.error("请勿重复添加字典值");
          return true;
        }
      } else if (!t1 && t2) {
        if (t2Name == false) {
          this.$Message.error("请勿重复添加字典值");
          return true;
        }
      } else if (t1 && t2) {
        if (t1Value == false || t2Name == false) {
          this.$Message.error("请勿重复添加字典值");
          return true;
        }
      }
      return false;
    },
    // 数据回显
    valueCopy() {
      this.formEdit = this.form;
      this.form.tag.forEach((ele) => {
        ele.subName = ele.itemName;
        ele.subValue = ele.itemValue;
      });
      this.children = this.form.tag;
      console.log("formEdit的值为", this.formEdit, "form的值为", this.form);
      this.$set(this.formEdit, "subName", "");
      this.$set(this.formEdit, "subValue", "");
      if (this.formEdit.extdata) {
        //配额数量
        this.$set(
          this.formEdit,
          "defaultNum",
          JSON.parse(this.formEdit.extdata).defaultNum
        );
        this.ruleCustoms["subName"] = [
          {
            trigger: "blur",
            pattern: /^[0-9]{1,5}$/,
            message: "配额数量只能输入整数，范围0-99999",
          },
        ];
      }
      if (this.formEdit.type == "SERVICE_TAG") {
        this.ruleCustoms["subName"] = [
          {
            trigger: "blur",
            max: 6,
            min: 1,
            message: "子项名称控制在6字以内",
          },
        ];
      }
    },
    clickTag(item, index) {
      this.formEdit.subName = item.subName;
      this.formEdit.subValue = item.subValue;
      this.idx = index;
    },
    delTag(index, item) {
      // 配额数量最少为5个
      if (this.formEdit.type == "SERVICE_NUM" && this.children.length <= 5) {
        this.$Message.warning("标签数量最少为5个");
        return;
      }
      //校验是否能删除
      if (item.id) {
        verifyDelete({ id: item.id }).then((res) => {
          this.children.splice(index, 1);
        });
      } else {
        this.children.splice(index, 1);
      }
    },
    confirm() {
      if(this.children.length > 16 && this.formEdit.type == "SERVICE_TAG") {
        this.$Message.warning("标签数量最多16个");
        return;
      }
      let data = this.formEdit;
      data.children = this.children;
      data.extdata = {
        defaultNum: data.defaultNum,
      };
      console.log(data, "data---");
      // return
      this.$refs.formEdit.validate((valid) => {
        if (valid) {
          this.loading = true;
          putItem(this.formEdit.id, data)
            .then((res) => {
              this.$Message.success("修改成功");
              this.loading = false;
              this.modalView = false;
              this.$emit("update:dialog", false);
              this.$emit("confirm");
              console.log(res, "更新字典");
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
    cancle() {
      this.modalView = false;
    },
    changeVisible(val) {
      this.modalView = false;
      if (!val) {
        this.$emit("update:dialog", false);
      }
    },
  },
};
</script>

<style lang="scss">
.editDict-modal {
  .message-nowrap {
    .ivu-form-item-error-tip {
      white-space: nowrap;
    }
  }
  .ivu-tag {
    margin: 0 12px 16px 0;
  }
}
</style>
